export default __webpack_public_path__ + "static/media/no-patients.dbee24e3.png";